import initialState from './initial_state';
import mutations from './mutations';

export default {
  namespaced: true,
  state: initialState(),
  mutations,
};
